import { useState, useEffect } from "react"
import Button from "./Button";
import { handleChangeUserName } from "../app/helpers/Utils";
import { useDispatch } from "react-redux";
import { getUserAfterNameChange } from "../features/auth/authSlice";



export const RenameModal = ({username, onClose, onUsernameChange}) => {
    const [currentName, setCurrentName] = useState(username);
    const [showError, setShowError] = useState(false);
    const dispatch = useDispatch();
    
    const modalStyle = {
        top : "50%",
        left: "50%",
        zIndex : "1001", // sits above UserSettings
        transform : "translate(-50%, -50%)",
        width: "512px",
        height: "350px",
        maxWidth: "95vw", /* Prevents overflow on small mobile screens */
        maxHeight: "60vh", /* Prevents overflow on short screens */
        background: "var(--bg-side)",
        padding: "16px 8px",
        overflowY: "auto",
        minWidth: "0",
        position: "absolute",
        /* Optional: standard modal aesthetics */
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
    }
    
    const onChangeUserName = async () => {
        if(!currentName.trim()){
            setShowError(true);
            return;
        }
        if(username !== currentName) {
            setShowError(false);
            console.log(username, currentName)
            await handleChangeUserName(username, currentName);
            onUsernameChange(currentName)
            await dispatch(getUserAfterNameChange());
            onClose();
        }
        onClose();
    }

    return (
        <div style={modalStyle} className="flex flex-col ">
            <label className="text-lg font-medium p-2">Change your username</label>
            <p className="text-sm font-light p-2">Enter a new username.</p>

            <label className="flex p-2 items-start font-medium">Username</label>
            <div className={`flex bg-[var(--bg-input)]  rounded-lg w-[95%] mx-auto`}>
                <input
                className='chat__input p-2  focus:border-blue-500 focus:rounded-lg focus:ring-2 focus:ring-blue-600  ' 
                autoFocus
                type='text'
                value={currentName}
                onChange={(e) => {setCurrentName(e.target.value)}}
                />
            </div>
            {showError && <div className="flex items-center justify-center text-red-400" >
                Name cannot be blank
            </div>}
            <div className="flex p-8 gap-4 justify-center">
                <Button className="w-1/2" text={"Cancel"} onClick={onClose} />
                <Button className="w-1/2" text={"Done"} onClick={onChangeUserName} color="rgb(200,100,200)" />
            </div>

        </div>
        
    )

}

export default RenameModal